import React from 'react'
import { Button, Col, Input, Label, Modal, Row } from 'reactstrap';

const FuelAdjustmentPopup = ({
    state,
    setState,
    tog_backdrop,
    target
}: any) => {
    return (
        <Modal
            size='lg'
            isOpen={state}
            toggle={() => {
                tog_backdrop();
            }}
            backdrop={"static"}
            id={target}
        >
            <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                    Fuel adjustment
                </h5>
                <button
                    onClick={() => {
                        setState(false);
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <Row className='mb-3'>
                    <Col lg={4}>
                        <Label className='mb-0'>Adjustment quantity</Label>
                        <Input
                            type='text'
                            name='quantity'
                            id='quantity'
                            className='form-control'
                        />
                    </Col>
                    <Col lg={4}>
                        <Label className='mb-0'>Reason for adjustment</Label>
                        <Input
                            type='textarea'
                            name='reason'
                            id='reason'
                            className='form-control'
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={{ size: 2, offset: 10 }}>
                        <Button type='button' className='btn btn-primary pos-end2' color='primary'>Adjust</Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    )
}

export default FuelAdjustmentPopup